import { SALESFORCE_SUPPORT_TICKETS } from "@shared/services/tour/urls/dashboard-urls.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import getSupportTickets from "@shared/services/tour/mockedApis/supportTickets/getSupportTickets.ts";

export default {
  [SALESFORCE_SUPPORT_TICKETS]: () => getSupportTickets(),
} satisfies TourUrlMapping;
